import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videoData';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'bg-primary-100/80 hover:bg-primary-200/80',
    text: 'text-primary-700',
    iconBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/80 hover:bg-accent-200/80',
    text: 'text-accent-700',
    iconBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/80 hover:bg-secondary-200/80',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-500',
  },
};

export default function CategoryGrid() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          全部分类
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-[500px] mx-auto">
          涵盖电视剧、电影、综艺、纪录片等多元内容，满足不同观看需求
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((cat) => {
          const colors = colorMap[cat.color] || colorMap.primary;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex flex-col items-center gap-3 p-6 rounded-xl transition-all duration-300 cursor-pointer group ${colors.bg}`}
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${colors.iconBg} text-background-50 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className={`font-heading text-base font-bold ${colors.text}`}>
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                {cat.description}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}